import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/evaluacion-de-riesgos-medioambientales-era")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/evaluacion-de-riesgos-medioambientales-era", statusCode: 301 }); },
});
